import { getLastAssessment } from './action'
import { USER_SUMMARY_RECEIVED, USER_SUMMARY_UPDATED, USER_SUMMARY_UNLOADED } from './types'

// TODO: USERDATANOT RECIVED ACTion
export default function user_summary(state = {}, action = {}){
  switch (action.type) {
    case USER_SUMMARY_RECEIVED:
      return action.user_summary
    case USER_SUMMARY_UPDATED:
      return {...state, lastAssessment: action.lastAssessment}
    case USER_SUMMARY_UNLOADED:
      return []
    default:
      return state;
  }
}
